import React from "react";
import AccountService from "../../services/AccountService"
import Container from 'react-bootstrap/Container';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

function validateEmail(email: string) {
    const re = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return re.test(String(email).toLowerCase());
}

export const ResetPassword: React.FC<{cancelCallback: ()=> void}> = (props) => {
    const [inProgress, setInProgress] = React.useState(false)
    const [emailSent, setEmailSent] = React.useState(false);

    const [message, setMessage] = React.useState<string | null>(null);
    const [error, setError] = React.useState<string | null>(null);

    const emailInputRef = React.useRef<HTMLInputElement>(null);

    React.useEffect(() => {
        document.title=`DimensionX | Sign Up`;
    }, []);

    function resetHandler() {
        if (!emailInputRef.current) {
            return
        }
        if (emailInputRef.current!.value.length == 0) {
            setError("Empty email");
            return;
        }

        if (!validateEmail(emailInputRef.current!.value)) {
            setError("Invalid email format");
            return
        }

        setError(null);
        setMessage("Sending reset password email..");
        setInProgress(true)
        AccountService.resetPassword(emailInputRef.current!.value.toLowerCase())
            .then(() => {
                setInProgress(false)
                setMessage(null);
                setEmailSent(true)
            })
            .catch((error: string) => {
                setInProgress(false)
                setMessage(null);
                setMessage(`Failed to reset password: ${error}`);
            })
    }
    return (
        <Container className="mt-5">
            <Row className="justify-content-center">
                <Col md={6}>
                    <h2 className="text-center mb-3">Reset Password</h2>
                    {!emailSent && (
                        <Form>
                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                <Form.Label>Email address</Form.Label>
                                <Form.Control type="email" placeholder="Enter email" autoFocus={true} ref={emailInputRef} required/>
                            </Form.Group>

                            { message && (<p className="text-secondary">{message}</p>)}
                            { error && (<p className="text-danger">{error}</p>)}
                            <Button variant="primary" className="w-100" onClick={resetHandler} disabled={inProgress}>
                                Reset Password
                            </Button>
                        </Form>
                    )}
                    {emailSent && (
                        <p>An email with the instructions was sent to <b>{emailInputRef.current!.value}</b></p>
                    )}
                    
                    <hr />

                    <div className="mt-3">
                        <Button variant="secondary"  className="w-100" disabled={inProgress} onClick={props.cancelCallback}>
                            Back to Login
                        </Button>
                    </div>
                </Col>
            </Row>
        </Container>
    );
};
